export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Update.vue?vue&type=template&id=7857644f"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Customers/Update.vue?vue&type=template&id=7857644f
// module id = 2572
// module chunks = 31